import { createSlice } from '@reduxjs/toolkit';
import {
  clearLocalStorage,
  persistLocalStorage,
} from '../../utilities/localstorage.utility';

export const EmptyUserState = {
  success: false,
  token: null,
  is_superuser: null,
  is_staff: null,
  organization_url: null,
  user_menu: null,
};

export const UserKey = 'user';

export const userSlice = createSlice({
  name: 'user',
  initialState: localStorage.getItem('user')
    ? JSON.parse(localStorage.getItem('user'))
    : EmptyUserState,
  reducers: {
    createUser: (state, action) => {
      persistLocalStorage(UserKey, action.payload);
      return action.payload;
    },
    updateUser: (state, action) => {
      const result = { ...state, ...action.payload };
      persistLocalStorage(UserKey, result);
      return { ...state, ...action.payload };
    },
    resetUser: () => {
      clearLocalStorage(UserKey);
      return EmptyUserState;
    },
  },
});

export const { createUser, updateUser, resetUser } = userSlice.actions;
